const STAGE = {
  homologation: {
    url: 'https://api.flashcover.hom.leaderaplicativos.com.br/api/v1',
  },
  production: {
    url: 'https://api.flashcover.leaderaplicativos.com.br/api/v1',
  },
};

export const API_URL = STAGE.homologation.url;

export const BROWSER_LANGUAGE = window.navigator.language;
